import { z } from 'zod';

const noteSchema = z.object({
  id: z.number().positive(),
  note: z
    .string()
    .max(5001, { message: 'Note must not exceed 5000 characters.' })
    .optional(),
});

export type NoteSchema = z.infer<typeof noteSchema>;

export type NoteErrors = {
  [K in keyof NoteSchema]?: string;
}

export const Note = () =>
  ({
    noteSchema,
  })
;
